var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlycol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0526 5C14.992 5 16.6865 6.03213 17.5994 7.56858H18.3158V7.56463H21.3939C21.406 7.56463 21.4179 7.56634 21.4298 7.56966C21.7478 7.5893 22 7.86835 22 8.20971V19.5H2V10.1293C2 9.77516 2.27134 9.4881 2.60606 9.4881H7.07811L7.08283 9.48465H7.83632C8.18093 6.95272 10.385 5 13.0526 5ZM13.0526 6.03571C14.3726 6.03571 15.5507 6.63333 16.3227 7.56858H14.1053V7.56463H12.303C11.9683 7.56463 11.697 7.85169 11.697 8.20579V9.4881H8.90032C9.23441 7.52872 10.9663 6.03571 13.0526 6.03571ZM16.4444 10.8C16.0353 10.8 15.7037 11.1246 15.7037 11.525V15.875C15.7037 16.2754 16.0353 16.6 16.4444 16.6C16.8535 16.6 17.1852 16.2754 17.1852 15.875V11.525C17.1852 11.1246 16.8535 10.8 16.4444 10.8Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlycol);
export default __webpack_public_path__ + "static/media/glycol.ecd37f10fa9226f0e002ec8601fe5cbe.svg";
export { ForwardRef as ReactComponent };